import { getWindowLocation } from '../../../utils/window';
const SIGNIN_PATH = '/SignIn';

export const getSignInUrl = () => {
  const location = getWindowLocation();

  return `${SIGNIN_PATH}?ReturnUrl=${encodeURIComponent(
    `${location.pathname}${location.search}`,
  )}`;
};
